import { Link } from "react-router-dom";

export default function EulaPage() {
  const updated = "May 10, 2026";
  return (
    <div className="min-h-screen bg-zinc-50 py-10 px-4 sm:px-8" data-testid="eula-page">
      <div className="max-w-3xl mx-auto bg-white border border-zinc-200 rounded-sm p-6 sm:p-10">
        <Link to="/" className="text-xs text-[#002FA7] hover:underline">&larr; Back to Expenser</Link>
        <h1 className="text-3xl font-bold tracking-tight text-zinc-900 mt-3" style={{ fontFamily: "DM Sans, sans-serif" }}>
          End User License Agreement
        </h1>
        <p className="text-xs text-zinc-400 mt-1">Last updated: {updated}</p>

        <div className="prose prose-sm mt-6 text-zinc-700 leading-6 space-y-4">
          <p>
            This End User License Agreement ("Agreement") is between you ("User") and C3 Contracting, LLC ("Company") and governs your
            use of the Expenser application ("Application"), including all related backend services, integrations, and supporting
            websites. By accessing or using the Application you agree to be bound by this Agreement.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">1. License Grant</h2>
          <p>
            The Company grants you a non-exclusive, non-transferable, revocable license to use the Application solely for your
            internal business purposes of capturing, coding, and submitting expenses for review and reimbursement, subject to the
            terms below. The Company retains all right, title, and interest in the Application and underlying intellectual property.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">2. Permitted Use</h2>
          <p>You may use the Application to:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Capture credit and debit card transactions from connected Mercury Bank accounts</li>
            <li>Code expenses to GL accounts and JobTread budget items</li>
            <li>Upload, store, and review receipts</li>
            <li>Submit expenses for approval and synchronize approved expenses to QuickBooks Online</li>
          </ul>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">3. Restrictions</h2>
          <p>You agree not to:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Reverse engineer, decompile, or disassemble the Application</li>
            <li>Use the Application to violate any applicable law, regulation, or third-party right</li>
            <li>Share your account credentials with another user or attempt to access another user's data</li>
            <li>Submit fraudulent, duplicated, or knowingly inaccurate expense data</li>
          </ul>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">4. Third-Party Services</h2>
          <p>
            The Application integrates with QuickBooks Online (Intuit Inc.), JobTread, and Mercury Bank. Use of these services is
            subject to each provider's own terms and privacy policies. You authorize the Application to retrieve, transmit, and store
            data exchanged with these services solely to perform the functions you request.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">5. Data Ownership and Confidentiality</h2>
          <p>
            You retain ownership of all data you submit to the Application. The Company will use commercially reasonable safeguards
            (encryption in transit, access controls, audit logging) to protect your data and will not disclose it except as required
            to provide the Application's functionality, comply with legal process, or as you direct.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">6. Disclaimer of Warranties</h2>
          <p>
            The Application is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether express or implied,
            including merchantability, fitness for a particular purpose, and non-infringement.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, the Company will not be liable for any indirect, incidental, special, or
            consequential damages, lost profits, or lost data arising out of or related to your use of the Application.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">8. Termination</h2>
          <p>
            This Agreement remains in effect until terminated. The Company may terminate access to the Application at any time for
            material breach. You may terminate by ceasing all use and disconnecting all integrations through the Settings page.
          </p>

          <h2 className="text-lg font-semibold text-zinc-900 pt-3">9. Contact</h2>
          <p>
            Questions about this Agreement may be directed to <a href="mailto:daniel.wayne@c3-contracting.com" className="text-[#002FA7] hover:underline">daniel.wayne@c3-contracting.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
